import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToOne } from "typeorm";

@Entity('rm_bom_log')
export class RmBomLog {

    @PrimaryGeneratedColumn("increment", { name: 'bom_log_id' })
    bomLogId: number;
    @Column("int", {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number;
    @Column("int", {
        nullable: false,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;
    @Column("int", {
        nullable: false,
        name: "product_id"
    })
    productId: number;
    @Column("int", {
        nullable: false,
        name: "min_grade"
    })
    minGrade: number;
    @Column("int", {
        nullable: false,
        name: "max_grade"
    })
    maxGrade: number;
    @Column("int", {
        nullable: false,
        name: "uom_id"
    })
    uomId: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "hl_per"
    })
    hlPercentage: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "final_per"
    })
    finalPercentage: number;
    @Column("int", {
        nullable: false,
        name: "min_count"
    })
    minCount: number;
    @Column("int", {
        nullable: false,
        name: "max_count"
    })
    maxCount: number;
    @Column("int", {
        nullable: false,
        name: "count"
    })
    count: number;
    @Column("int", {
        nullable: false,
        name: "required_count"
    })
    requiredCount: number;
    @Column("int", {
        nullable: false,
        name: "count_range_id"
    })
    countRangeId: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "case_weight"
    })
    caseWeight: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "min_weight"
    })
    oupPutMinWeight: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "max_weight"
    })
    oupPutMaxWeight: number;
    @Column("int",{
        nullable: false,
        name: "cases"
    })
    cases: number;
    @Column("int", {
        nullable: false,
        name: "ratio"
    })
    ratio: number;
    @Column({
        type: 'decimal', precision: 10, scale: 2,
        nullable: false,
        name: "quantity",
        default: 0,
    })
    quantity: number;

    @Column({
        type: 'decimal', precision: 10, scale: 2,
        nullable: false,
        name: "assigned_quantity",
        default: 0,
    })
    assignedQuantity: number;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;
    @Column("varchar", {
        nullable: false,
        default: "Admin",
        name: "created_user"
    })
    createdUser: string | null;
    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;
    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;
    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    //   @ManyToOne(type=>SaleOrder, saleOrder=>saleOrder.BomDetailsInfo, {  nullable:false })
    //   @JoinColumn({ name:"sale_order_id"})
    //   saleOrderInfo: SaleOrder;
}
